import { ApiResponse, IContactUsRequest } from '@/types';

import http from '../http';

export const contactFormRequest = async (payload: IContactUsRequest) =>
  http.post<ApiResponse<null>>('/contact-us', payload, { auth: false });
